<div
  class="visualization-container"
  [style.border-color]="borderColor"
  [style.background-color]="backgroundColor"
  [style.gap.rem]="(distributionsAreEqual$ | async) ? 1 : 1.5">
  <div class="label-sm">{{ label }}</div>
  <div
    *ngFor="let named of instructionsForDisplay$ | async; trackBy: trackByAccountId"
    class="d-flex flex-column gap-3">
    <div *ngIf="!(distributionsAreEqual$ | async)" class="d-flex flex-column gap-2">
      <div class="employer-name">{{ named.accountName }}</div>
      <div class="account-id">{{ named.instruction?.accountDetails?.accountId }}</div>
    </div>
    <div #grid [ngStyle]="gridStyles$ | async">
      <app-investment-instructions-card
        *ngFor="let instruction of named.instruction?.investmentInstructions"
        [instruction]="instruction" />
    </div>
  </div>
</div>
